
import { CalendarDays } from "lucide-react";

interface DayLabelProps {
  day: string;
}

export const DayLabel = ({ day }: DayLabelProps) => {
  const getDayLabel = (day: string) => {
    const days: Record<string, string> = {
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
      sunday: 'Domingo'
    };
    return days[day] || day;
  };

  return (
    <div className="flex items-center gap-2 mt-2 text-sm text-white/60">
      <CalendarDays className="w-4 h-4" />
      <span>{getDayLabel(day)}</span>
    </div>
  );
};
